import {AssetStatus, type IAsset} from '@netx/core-asset-next/schema';

export const isAssetCheckedOut = (asset: Pick<IAsset, 'status'>) =>
	asset.status === AssetStatus.CHECKOUT;

export default isAssetCheckedOut;
